// 🔴 N°1028/N°1035 — « CGV : ON/OFF » PAR DEVIS.
// L'état AFFICHÉ est l'état RÉELLEMENT appliqué : `devis.cgv_jointes_effectif` (serveur : choix du devis, sinon réglage du
// gabarit du tenant). ⛔ Jamais un « ON » supposé : un gabarit qui éteint les CGV s'affiche OFF.
// 🔴 N°1030 — l'assistant remplace le devis par la réponse de chaque sauvegarde, qui ne porte pas l'état effectif :
//    quand il est inconnu, il est relu au serveur (GET du devis) au lieu d'être supposé.
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { enteteTenant } from "../../../utils/enteteTenant";

const API = process.env.REACT_APP_BACKEND_URL;

const connu = (devis) => typeof devis?.cgv_jointes_effectif === "boolean" || typeof devis?.cgv_jointes === "boolean";

export function etatCgv(devis, choixLocal, effectifServeur = null) {
  if (choixLocal !== null && choixLocal !== undefined) return choixLocal;
  if (typeof devis?.cgv_jointes_effectif === "boolean") return devis.cgv_jointes_effectif;
  if (typeof devis?.cgv_jointes === "boolean") return devis.cgv_jointes;
  if (typeof effectifServeur === "boolean") return effectifServeur;
  return true;                                   // serveur ancien sans le champ : comportement historique (CGV jointes)
}

function entetes(tenantId, json) {
  const token = localStorage.getItem("session_token");
  return { ...(json ? { "Content-Type": "application/json" } : {}), ...enteteTenant(tenantId),
           ...(token && { Authorization: `Bearer ${token}` }) };
}

export default function CgvDevisToggle({ devis, tenantId }) {
  const [choix, setChoix] = useState(null);      // null = pas touché ⇒ état serveur
  const [envoi, setEnvoi] = useState(false);
  const [effectifServeur, setEffectifServeur] = useState(null);
  const [lecture, setLecture] = useState(false);
  const aLire = Boolean(devis?.id) && !connu(devis) && choix === null;

  useEffect(() => {
    if (!aLire) return undefined;
    let vivant = true;
    setLecture(true);
    fetch(`${API}/api/metier/devis/${devis.id}`, { credentials: "include", headers: entetes(tenantId) })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { const d = j?.devis || j; if (vivant && typeof d?.cgv_jointes_effectif === "boolean") setEffectifServeur(d.cgv_jointes_effectif); })
      .catch(() => {})
      .finally(() => { if (vivant) setLecture(false); });
    return () => { vivant = false; };
  }, [aLire, devis?.id, tenantId]);

  const jointes = etatCgv(devis, choix, effectifServeur);

  const basculer = async (valeur) => {
    if (!devis?.id) return;
    const avant = jointes; setChoix(valeur); setEnvoi(true);
    try {
      const res = await fetch(`${API}/api/metier/devis/${devis.id}`, {
        method: "PUT", credentials: "include", headers: entetes(tenantId, true),
        body: JSON.stringify({ cgv_jointes: valeur }),
      });
      if (!res.ok) throw new Error("refus");
    } catch { setChoix(avant); toast.error("Choix des CGV non enregistré"); }
    finally { setEnvoi(false); }
  };

  return (
    <label className="flex items-center gap-2 mt-3 text-sm text-[var(--oh-text)]" data-testid="devis-cgv-toggle-label">
      <input type="checkbox" data-testid="devis-cgv-toggle" checked={!lecture && jointes} disabled={envoi || lecture || !devis?.id}
             aria-label="Joindre les CGV à ce devis" onChange={(ev) => basculer(ev.target.checked)} />
      {lecture ? "CGV : vérification…" : `CGV : ${jointes ? "ON — jointes au devis" : "OFF — non jointes"}`}
    </label>
  );
}
